import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export const PERMISSION_CATEGORY = {
  USER_MANAGEMENT_AND_AUTH: 'UserManagementAndAuth',
  REFERENTIAL_DATA: 'ReferentialData',
  ORDER_AND_LOGISTICS: 'OrderAndLogistics',
  FILE_AND_WORKFLOW: 'FileAndWorkflow',
  FIELD_SERVICE_AND_REPAIR: 'FieldServiceAndRepair',
  MESSAGING: 'Messaging',
  BILLING_AND_PAYMENTS: 'BillingAndPayments',
  CLAIMS: 'Claims',
  STOCK_AND_SPARE_PARTS: 'StockAndSpareParts',
  ANALYTICS_AND_IO: 'AnalyticsAndIO',
  CONSOLE: 'Console',
  PARTNER_MANAGEMENT: 'PartnerManagement',
  OTHER: 'Other',
} as const;

export type PermissionCategory =
  (typeof PERMISSION_CATEGORY)[keyof typeof PERMISSION_CATEGORY];

export interface AssignablePermissionDescriptor {
  shortName?: string;
  description?: string;
  descriptionTranslationKey?: string;
}

export interface AssignablePermissionsByCategory {
  category: PermissionCategory;
  translationKey?: string;
  descriptionTranslationKey?: string;
  icon?: string;
  permissions?: AssignablePermissionDescriptor[];
}

const ENDPOINT = `${APIConfiguration.authorization}permissions/assignablePermissionsByCategory`;

export const getAssignablePermissionsByCategoryQuery = async (): Promise<
  BackResponse<AssignablePermissionsByCategory[]> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<AssignablePermissionsByCategory[]>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
